/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return -- globalThis.__intlCache is untyped by design (must work in compiled i18n context) */
// IMPORTANT: The formatter function must be fully self-contained with NO references
// to module-scoped variables or functions. The i18n message compiler (compile-messages)
// serializes these function bodies into standalone JS files (e.g. en.js), where
// module-scoped references like helper functions or caches are not in scope.
// Only language built-ins (globalThis, Map, Intl, Number) are safe to use.

export function puNumber(
  value: number,
  locale: string,
  options?: string,
): string {
  const o = options || ''
  if (typeof value !== 'number') {
    return ''
  }
  const style = getStyleFromOptions(o)
  const minFrac = getMinFractionDigitsFromOptions(o)
  const maxFrac = getMaxFractionDigitsFromOptions(o)

  const cache = ((globalThis as any).__intlCache ??= new Map())
  const cacheKey = `num|${locale}|${style}|${minFrac}|${maxFrac ?? ''}`
  let formatter = cache.get(cacheKey)
  if (!formatter) {
    const config: Intl.NumberFormatOptions = {
      style: style as keyof Intl.NumberFormatOptionsStyleRegistry,
      minimumFractionDigits: minFrac,
    }
    if (maxFrac !== undefined) {
      config.maximumFractionDigits = maxFrac
    }
    formatter = new Intl.NumberFormat(locale, config)
    cache.set(cacheKey, formatter)
  }
  return formatter.format(value)

  function getFromOptions(options: string, optionToFind: string): string {
    const option = options.split(' ').find((o) => o.startsWith(optionToFind))
    return option ? option.split(':')[1] : ''
  }

  function getStyleFromOptions(options: string): string {
    const style = getFromOptions(options, 'style')
    return style || 'decimal'
  }

  function getMinFractionDigitsFromOptions(options: string): number {
    const minimumFractionDigits = getFromOptions(
      options,
      'minimumFractionDigits',
    )
    return minimumFractionDigits ? parseInt(minimumFractionDigits) : 0
  }

  function getMaxFractionDigitsFromOptions(options: string) {
    const maximumFractionDigits = getFromOptions(
      options,
      'maximumFractionDigits',
    )
    return maximumFractionDigits ? parseInt(maximumFractionDigits) : undefined
  }
}
